import LanguageChoices from "../Common/locales/locales_components/language_choices";
import {useTranslation} from "react-i18next";
import {Tab} from "./dashboardTabs";
import logo from '../../assets/images/mariposaEB_logo_no_background.png';

interface AdminSidebarProps {
    tabs: {
        id: Tab;
        label: string;
    }[];
    activeTab: Tab;
    menuOpen: boolean;
    onTabChange: (tab: Tab) => void;
    onLogout: () => void;
}

export const AdminSidebar = ({
                          tabs,
                          activeTab,
                          menuOpen,
                          onTabChange,
                          onLogout,
                      }: AdminSidebarProps) => {
    const { t } = useTranslation();

    return (
        <aside className={`admin-sidebar ${menuOpen ? 'open' : ''}`}>
            <div className="admin-sidebar-logo">
                <img src={logo} alt="logo" />

                <span>{t('admin.dashboard.mariposa')}</span>

                <small>{t('admin.dashboard.admin')}</small>

                <div className="switch_languages">
                    <LanguageChoices />
                </div>
            </div>

            <nav>
                {tabs.map(item => (
                    <button
                        key={item.id}
                        className={`admin-nav-item ${
                            activeTab === item.id ? 'active' : ''
                        }`}
                        onClick={() => onTabChange(item.id)}
                    >
                        {item.label}
                    </button>
                ))}
            </nav>

            <div className="admin-sidebar-footer">
                <button onClick={onLogout}>
                    {t('admin.dashboard.logout')}
                </button>
            </div>
        </aside>
    );
};
